// extracted by mini-css-extract-plugin
export default {"card-container":"patient-info-card_card-container__zHaRP"};